import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import {  agentsByProjectId } from "../graphql/queries";
import {  AgentsByProjectIdQuery, } from "../API";



export async function fetchLLMAgents(
  projectId: string
): Promise<GraphQLResult<AgentsByProjectIdQuery>> {
  
  return API.graphql(
    graphqlOperation( agentsByProjectId, {
      projectId: projectId,
    })
  ) as Promise<GraphQLResult<AgentsByProjectIdQuery>>;
}